import React from 'react';
import { Redirect } from 'react-router-dom';

import { useLocalStorage } from 'utils/hooks/useLocalStorage';
import { ROUTES } from 'utils/constants';
import { KEYS } from 'components/evieOnboarding/utils/constants';

import NewHome from 'views/NewHome';

// The same SPA serves the clinic site and the Evie patient app on different
// domains. Only on patient hosts does the bare root redirect into the app
// (logged in → assistant, logged out → login); everywhere else the clinic
// homepage stays untouched.
const EVIE_PATIENT_HOSTS = ['join.hievie.com', 'healthphy-dev.s3-website-sa-east-1.amazonaws.com'];

const RootRedirect = () => {
  const [userToken] = useLocalStorage(KEYS.USER_TOKEN);
  const isPatientHost = EVIE_PATIENT_HOSTS.includes(window.location.hostname);

  if (!isPatientHost) return <NewHome />;

  return <Redirect to={userToken ? ROUTES.EVIE_ASSISTANT : ROUTES.EVIE_LOGIN} />;
};

export default RootRedirect;
